import { useSyncExternalStore } from 'react';
import type { Session } from '@supabase/supabase-js';
import { getSession, onSessionChange } from '@/lib/auth-session';

/**
 * Reactive read of the app's single session cache (lib/auth-session.ts).
 * Re-renders the calling component on SIGNED_IN/SIGNED_OUT/TOKEN_REFRESHED/
 * USER_UPDATED and on the initial session being seeded -- never calls
 * Supabase itself, purely subscribes to the shared in-memory cache.
 */
export function useSession(): Session | null {
  return useSyncExternalStore(onSessionChange, getSession, getSession);
}
